<div class="relative-wrapper">
  <div #tagSection class="tag-section" *ngIf="searchTags||customTags">

    <!-- 赤タグ／緑タグ／青タグの順番 -->
    <div class="tag-box-wrapper">
      <div #tagBox class="tag-box" [@closeOpen]="open?'open':'close'">
        <ng-container *ngFor="let searchTag of qoalaTags">
          <app-search-tag [searchTag]="searchTag" (clickedQoalaTag)="clickedQoalaTag()"
            (clickedUserTag)="clickedUserTag($event)">
          </app-search-tag>
        </ng-container>

        <ng-container *ngFor="let tag of customTags">
          <app-tag-button [tagName]="tag.tag_name" [buttonMode]="true" [color]="'green'"
            [activated]="selectedTagIds.includes(tag.id)"
            (tagClick)="selectTag($event,tag.id)"
            (tagDelete)="openConfirmDeleteCustomTagModal(tag, confirmDeleteCustomTagModal)">
          </app-tag-button>
        </ng-container>

        <ng-container *ngFor="let searchTag of userTags">
          <app-search-tag [searchTag]="searchTag" (clickedQoalaTag)="clickedQoalaTag()"
            (clickedUserTag)="clickedUserTag($event)">
          </app-search-tag>
        </ng-container>

      </div>
    </div>
  </div>
</div>

<!-- NOTE: いろんな所に点在している削除確認モーダルをまとめれるならまとめたい -->
<ng-template #confirmDeleteCustomTagModal let-modal>
  <div class="modal-section">
    <div class="modal-header">
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
        <span class="close-button" aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="modal-body">
      <p>
        タグ名: {{ targetCustomTag.tag_name }} <br>
        上記のタグを削除します。<br>
        削除後は取り消しできません。削除しますか？
      </p>
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-dark" (click)="modal.dismiss()" ngbAutofocus>キャンセル</button>
        <button type="button" class="btn btn-primary-dark" (click)="deleteCustomTag()">はい</button>
      </div>
    </div>
  </div>
</ng-template>
